import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { INGREDIENTS_QUERY } from '../../common/graphql/queries'
import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENTS_BY_KEYWORD_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENTS } from '../redux/action-types'
import { cleanupFetchIngredients } from '../redux/actions'

const useIngredientsQuery = (searchTerm, areDiscardedIncluded) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchIngredients)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.ingredients.ingredients,
  )

  const refetch = useCallback(
    (searchTerm, areDiscardedIncluded) => {
      if (isEmpty(searchTerm)) {
        return apolloService.query(
          INGREDIENTS_QUERY,
          {},
          dispatch,
          FETCH_INGREDIENTS,
        )
      }

      const data = { searchTerm, areDiscardedIncluded }
      return apolloService.query(
        INGREDIENTS_BY_KEYWORD_QUERY,
        { data },
        dispatch,
        FETCH_INGREDIENTS,
      )
    },
    [dispatch],
  )

  useEffect(() => {
    refetch(searchTerm, areDiscardedIncluded)
  }, [refetch, searchTerm, areDiscardedIncluded])

  return { isLoading, error, refetch, initialData, latestEvent }
}

export default useIngredientsQuery
